/**
 * Copyright (c) 2019 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

/* to be moved to a common utils lib */

let isVisible = true;

const browserPrefixes = ['moz', 'ms', 'o', 'webkit'];
const getHiddenPropertyName = (prefix) => (prefix ? prefix + 'Hidden' : 'hidden');
const getVisibilityEvent = (prefix) => (prefix ? prefix : '') + 'visibilitychange';
const getBrowserPrefix = (browserPrefixes) =>
  browserPrefixes.find((prefix) => getHiddenPropertyName(prefix) in document);
const browserPrefix = getBrowserPrefix(browserPrefixes);
const hiddenPropertyName = getHiddenPropertyName(browserPrefix);
const visibilityEventName = getVisibilityEvent(browserPrefix);

const onVisible = (callback = () => {}) => {
  if (isVisible) return;
  isVisible = true;
  callback();
};

const onHidden = (callback = () => {}) => {
  if (!isVisible) return;
  isVisible = false;
  callback();
};

let visibleCallback;
let hiddenCallback;
const onVisibilityChange = () => (document[hiddenPropertyName] ? onHidden(hiddenCallback) : onVisible(visibleCallback));

const onPageFocus = () => onVisible(visibleCallback);
const onPageBlur = () => onHidden(hiddenCallback);

const unsubscribe = () => {
  document.removeEventListener(visibilityEventName, onVisibilityChange);
  document.removeEventListener('focus', onPageFocus);
  window.removeEventListener('focus', onPageFocus);
  document.removeEventListener('blur', onPageBlur);
  window.removeEventListener('blur', onPageBlur);
};

const subscribe = (onVisible, onHiden) => {
  unsubscribe();

  visibleCallback = onVisible;
  hiddenCallback = onHiden;

  document.addEventListener(visibilityEventName, onVisibilityChange, false);
  document.addEventListener('focus', onPageFocus, false);
  window.addEventListener('focus', onPageFocus, false);
  document.addEventListener('blur', onPageBlur, false);
  window.addEventListener('blur', onPageBlur, false);
};

export default { subscribe, unsubscribe };
